import React, { useContext, useRef } from 'react'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import { useSettingsContext } from '@app/layout/settings'
import { SnackbarProvider as NotistackProvider, VariantType, closeSnackbar, enqueueSnackbar } from 'notistack'
import { StyledIcon, StyledNotistack } from './styles'
import Iconify from '../iconify'

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode
}

export default function SnackbarProvider({ children }: Props) {
  const settings = useSettingsContext()

  const isRTL = settings.themeDirection === 'rtl'

  const notistackRef = useRef<any>(null)

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      TransitionComponent={isRTL ? Collapse : undefined}
      variant="success" // Set default variant
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <Iconify icon="eva:info-fill" width={24} />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <Iconify icon="eva:checkmark-circle-2-fill" width={24} />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <Iconify icon="eva:alert-triangle-fill" width={24} />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <Iconify icon="solar:danger-bold" width={24} />
          </StyledIcon>
        )
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack
      }}
      // with close as default
      // eslint-disable-next-line react/no-unstable-nested-components
      action={(snackbarId: any) => (
        <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} sx={{ p: 0.5 }}>
          <Iconify width={16} icon="mingcute:close-line" />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  )
}

// ----------------------------------------------------------------

export const showNotiStack = (message: string = '', variant: VariantType = 'success') => {
  let nMsg = message
  if (!message && (variant === 'error' || variant === 'warning')) {
    nMsg = 'Something went wrong'
  } else if (!message) {
    nMsg = 'Success'
  }

  enqueueSnackbar(nMsg, { variant })
}
